import { Suspense, lazy, useEffect } from "react"
import { LoginInfo } from "@/components/auth/LoginInfo"
import { useNavigate } from "react-router-dom"
import { supabase } from "@/integrations/supabase/client"

// Lazy load do componente LoginForm
const LoginForm = lazy(() => import("@/components/auth/LoginForm"))

export default function Login() {
  const navigate = useNavigate()

  useEffect(() => {
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession()
      if (session) {
        navigate('/')
      }
    }

    checkSession()
  }, [navigate])

  return (
    <div className="min-h-screen flex">
      {/* Left side - Login Form */}
      <div className="w-full md:w-[45%] bg-gradient-to-br from-primary/5 via-primary/10 to-secondary/5 flex items-center justify-center p-4">
        <div className="w-full max-w-md space-y-8 glass-card p-8 rounded-2xl">
          {/* Header */}
          <div className="space-y-2 text-center">
            <h1 className="text-3xl font-bold tracking-tight text-gray-900">
              Bem-vindo
            </h1>
            <p className="text-muted-foreground">
              Digite suas credenciais para acessar o sistema
            </p>
          </div>

          <Suspense fallback={
            <div className="flex items-center justify-center py-8">
              <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-r-transparent" />
            </div>
          }>
            <LoginForm />
          </Suspense>
        </div>
      </div>

      {/* Right side - Image */}
      <div className="hidden md:block md:w-[55%] relative">
        {/* Background Image with Loading State */}
        <div className="w-full h-full bg-gray-100 animate-pulse">
          <img
            src="/lovable-uploads/38bbc00b-88b2-4c0b-8a6f-03e8982f4ad8.png"
            alt="Congresso Nacional ao anoitecer"
            className="w-full h-full object-cover transition-opacity duration-300"
            loading="lazy"
            onLoad={(e) => {
              const target = e.target as HTMLImageElement;
              target.classList.remove('opacity-0');
              target.classList.add('opacity-100');
              target.parentElement?.classList.remove('animate-pulse');
            }}
          />
        </div>
        
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
        
        {/* Info Card - Positioned higher */}
        <div className="absolute inset-0 flex items-start justify-center px-8 pt-32">
          <div className="bg-black/40 rounded-2xl p-6 border border-white/20 shadow-2xl transition-all duration-300 hover:brightness-120 max-w-xl">
            <LoginInfo />
          </div>
        </div>

        {/* Footer credit */}
        <div className="absolute bottom-6 left-0 right-0 flex items-center justify-center space-x-2 text-white/80 text-sm">
          <span>Desenvolvido por</span>
          <div className="h-5 w-5 bg-gray-100 animate-pulse rounded-sm">
            <img 
              src="/lovable-uploads/f5a64a17-9f92-4235-b305-3b15254a1708.png" 
              alt="Bee Path Logo" 
              className="h-5 w-5 bg-white p-0.5 rounded-sm transition-opacity duration-300"
              loading="lazy"
              onLoad={(e) => {
                const target = e.target as HTMLImageElement;
                target.classList.remove('opacity-0');
                target.classList.add('opacity-100');
                target.parentElement?.classList.remove('animate-pulse');
              }}
            />
          </div>
          <span className="font-semibold">
            Bee Path - Tecnologia Avançada com IA
          </span>
        </div>
      </div>
    </div>
  )
}